<template>
  <div style="display: inline-block">
    <breadcrump
      v-if="item.parent_id"
      :item="parentRoute"
      :routes="routes"
      class="mr-3"
    />
    <b-button
      :icon-left="item.parent_id ? 'angle-right' : ''"
      :label="item.name"
      size="is-small"
      class="search-result-breadcrump is-italic"
    />
  </div>
</template>

<script>
export default {
  name: 'Breadcrump',

  props: {
    routes: {
      type: Array,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
  },

  computed: {
    parentRoute() {
      return this.routes.find((route) => route.id === this.item.parent_id);
    },
  },

  methods: {
    theRoute(id) {
      this.routes.find((route) => route.id === id);
    },
  },
};
</script>

<style>
.button.search-result-breadcrump {
  border: none;
  padding: 0;
  color: #ac8856;
  background-color: transparent;
}
</style>
